var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeGoogleplay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 54,
    viewBox: "0 0 180 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 54,
    rx: 10,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 52,
    rx: 9,
    x: 1,
    y: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5l16.5 9.5-16.5 9.5V13.5z",
    fill: "#fff",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5l8.5 8.5-8.5 8.5V13.5z",
    fill: "#00D4AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22l8 4.6-8 4.6V22z",
    fill: "#FFD400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5l8.5 8.5-4.2 4.2L14 13.5z",
    fill: "#FF3D5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32.5l8.5-8.5-4.2-4.2L14 32.5z",
    fill: "#00AAFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 21,
    fontFamily: "Roboto, sans-serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.85
  }, "Get it on")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 38,
    fontFamily: "Roboto, sans-serif",
    fontSize: 18,
    fontWeight: 500,
    fill: "#fff"
  }, "Google Play")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGoogleplay);
export default __webpack_public_path__ + "static/media/badge-googleplay.0370dc85afff31306249e7412dab5384.svg";
export { ForwardRef as ReactComponent };